// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.support-tickets-page {
  max-width: 440px;
  margin: 0 auto;
  padding: 0 10px 32px 10px;
  position: relative;
}

.support-header-row {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
  margin-bottom: 14px;
}

.support-header-actions {
  display: flex;
  justify-content: flex-end;
}

.support-tickets-title {
  text-align: center;
  font-size: 1.28rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  margin: 18px 0 24px 0;
  color: #232137;
  font-family: "Cera Pro", Arial, sans-serif;
}

.support-tickets-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.support-ticket-card {
  background: #fff;
  border-radius: 17px;
  box-shadow: 0 2px 14px 0 rgba(36, 41, 57, 0.09);
  padding: 15px 14px 13px 14px;
  cursor: pointer;
  transition: box-shadow 0.18s;
  border-left: 5px solid #d8dae9;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.support-ticket-card:active {
  box-shadow: 0 2px 8px 0 rgba(231, 47, 68, 0.13);
}

.status-open {
  border-left-color: #e72f44;
}

.status-waiting {
  border-left-color: #f2b705;
}

.status-closed {
  border-left-color: #2f9e44;
}

.status-archived {
  border-left-color: #bfc2d1;
}

.ticket-urgent-flag {
  align-self: flex-start;
  max-width: 100%;
  padding: 5px 9px 4px;
  border: 1px solid #fecdd3;
  border-radius: 10px;
  background: #fff1f2;
  color: #be123c;
  font-size: 0.87rem;
  font-weight: 800;
  line-height: 1.18;
  overflow-wrap: anywhere;
}

.ticket-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.ticket-title {
  font-size: 1.08rem;
  font-weight: 700;
  color: #232137;
  flex: 1 1 auto;
  min-width: 0;
  line-height: 1.17;
  overflow-wrap: anywhere;
}

.ticket-status {
  font-size: 0.97rem;
  font-weight: 600;
  padding: 2px 13px 2px 10px;
  border-radius: 13px;
  color: #fff;
  background: #e72f44;
  min-width: 80px;
  max-width: 46%;
  flex: 0 0 auto;
  text-align: center;
  letter-spacing: 0.01em;
  overflow-wrap: anywhere;
}

.status-waiting .ticket-status {
  background: #f2b705;
  color: #232137;
}

.status-closed .ticket-status {
  background: #2f9e44;
  color: #fff;
}

.status-archived .ticket-status {
  background: #bfc2d1;
  color: #fff;
}

.ticket-object {
  font-size: 0.96rem;
  color: #7878a0;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.ticket-object b {
  color: #232137;
  font-weight: 700;
}

.ticket-card-dates {
  display: flex;
  gap: 16px;
  font-size: 0.98rem;
  color: #7878a0;
  flex-wrap: wrap;
}

.ticket-date b, .ticket-last b {
  color: #232137;
  font-weight: 700;
}

.support-new-ticket-btn {
  background: #e72f44;
  color: #fff;
  font-size: 1.01rem;
  font-weight: 700;
  border: none;
  border-radius: 18px;
  box-shadow: 0 2px 12px 0 rgba(231, 47, 68, 0.11);
  letter-spacing: 0.01em;
  cursor: pointer;
  font-family: "Cera Pro", Arial, sans-serif;
  transition: background 0.13s;
  padding: 10px 17px 7px 17px;
  align-self: flex-end;
}

.support-new-ticket-btn:active {
  background: #c41d38;
}

.support-old-closed-toggle {
  width: 100%;
  margin: 0 0 14px 0;
  border: 1px solid #d8dae9;
  background: #fff;
  color: #232137;
  font-size: 0.98rem;
  font-weight: 700;
  border-radius: 14px;
  padding: 11px 12px 9px 12px;
  cursor: pointer;
  font-family: "Cera Pro", Arial, sans-serif;
  box-shadow: 0 2px 10px 0 rgba(36, 41, 57, 0.06);
}

.support-old-closed-toggle:active {
  background: #f5f6fb;
}

@media (max-width: 430px) {
  .support-header-actions {
    justify-content: stretch;
  }
  .support-new-ticket-btn {
    width: 100%;
    align-self: stretch;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/SupportTicketsPage/supportTickets.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,cAAA;EACA,0CAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,+CAAA;EACA,4BAAA;EACA,eAAA;EACA,4BAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,+CAAA;AACF;;AAEA;EAAe,0BAAA;AAEf;;AADA;EAAkB,0BAAA;AAKlB;;AAJA;EAAiB,0BAAA;AAQjB;;AAPA;EAAmB,0BAAA;AAWnB;;AATA;EACE,sBAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAYF;;AATA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;AAYF;;AATA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAYF;;AATA;EACE,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;AAYF;;AATA;EACE,mBAAA;EACA,cAAA;AAYF;;AAVA;EACE,mBAAA;EACA,WAAA;AAaF;;AAXA;EACE,mBAAA;EACA,WAAA;AAcF;;AAXA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;AAcF;;AAXA;EACE,cAAA;EACA,gBAAA;AAcF;;AAXA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAcF;;AAXA;EACE,cAAA;EACA,gBAAA;AAcF;;AAXA;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,gDAAA;EACA,sBAAA;EACA,eAAA;EACA,0CAAA;EACA,4BAAA;EACA,2BAAA;EACA,oBAAA;AAcF;;AAZA;EAAiC,mBAAA;AAgBjC;;AAdA;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,0CAAA;EACA,+CAAA;AAiBF;;AAdA;EACE,mBAAA;AAiBF;;AAdA;EACE;IACE,wBAAA;EAiBF;EAdA;IACE,WAAA;IACA,mBAAA;EAgBF;AACF","sourcesContent":[".support-tickets-page {\r\n  max-width: 440px;\r\n  margin: 0 auto;\r\n  padding: 0 10px 32px 10px;\r\n  position: relative;\r\n}\r\n\r\n.support-header-row {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.support-header-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\r\n.support-tickets-title {\r\n  text-align: center;\r\n  font-size: 1.28rem;\r\n  font-weight: 800;\r\n  letter-spacing: -0.02em;\r\n  margin: 18px 0 24px 0;\r\n  color: #232137;\r\n  font-family: 'Cera Pro', Arial, sans-serif;\r\n}\r\n\r\n.support-tickets-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n}\r\n\r\n.support-ticket-card {\r\n  background: #fff;\r\n  border-radius: 17px;\r\n  box-shadow: 0 2px 14px 0 rgba(36,41,57,0.09);\r\n  padding: 15px 14px 13px 14px;\r\n  cursor: pointer;\r\n  transition: box-shadow .18s;\r\n  border-left: 5px solid #d8dae9;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.support-ticket-card:active {\r\n  box-shadow: 0 2px 8px 0 rgba(231,47,68,0.13);\r\n}\r\n\r\n.status-open { border-left-color: #e72f44; }\n.status-waiting { border-left-color: #f2b705; }\n.status-closed { border-left-color: #2f9e44; }\n.status-archived { border-left-color: #bfc2d1; }\n\n.ticket-urgent-flag {\n  align-self: flex-start;\n  max-width: 100%;\n  padding: 5px 9px 4px;\n  border: 1px solid #fecdd3;\n  border-radius: 10px;\n  background: #fff1f2;\n  color: #be123c;\n  font-size: 0.87rem;\n  font-weight: 800;\n  line-height: 1.18;\n  overflow-wrap: anywhere;\n}\n\n.ticket-card-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n}\n\r\n.ticket-title {\r\n  font-size: 1.08rem;\r\n  font-weight: 700;\r\n  color: #232137;\n  flex: 1 1 auto;\n  min-width: 0;\n  line-height: 1.17;\n  overflow-wrap: anywhere;\n}\n\n.ticket-status {\n  font-size: 0.97rem;\n  font-weight: 600;\n  padding: 2px 13px 2px 10px;\r\n  border-radius: 13px;\r\n  color: #fff;\r\n  background: #e72f44;\n  min-width: 80px;\n  max-width: 46%;\n  flex: 0 0 auto;\n  text-align: center;\n  letter-spacing: 0.01em;\n  overflow-wrap: anywhere;\n}\n\n.status-waiting .ticket-status {\n  background: #f2b705;\n  color: #232137;\n}\n.status-closed .ticket-status {\n  background: #2f9e44;\n  color: #fff;\n}\n.status-archived .ticket-status {\n  background: #bfc2d1;\n  color: #fff;\n}\n\n.ticket-object {\n  font-size: 0.96rem;\n  color: #7878a0;\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n}\n\n.ticket-object b {\n  color: #232137;\n  font-weight: 700;\n}\n\n.ticket-card-dates {\n  display: flex;\n  gap: 16px;\n  font-size: 0.98rem;\r\n  color: #7878a0;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.ticket-date b, .ticket-last b {\r\n  color: #232137;\r\n  font-weight: 700;\r\n}\r\n\r\n.support-new-ticket-btn {\n  background: #e72f44;\n  color: #fff;\n  font-size: 1.01rem;\n  font-weight: 700;\r\n  border: none;\r\n  border-radius: 18px;\r\n  box-shadow: 0 2px 12px 0 rgba(231,47,68,0.11);\r\n  letter-spacing: 0.01em;\r\n  cursor: pointer;\r\n  font-family: 'Cera Pro', Arial, sans-serif;\r\n  transition: background .13s;\n  padding: 10px 17px 7px 17px;\n  align-self: flex-end;\n}\n.support-new-ticket-btn:active { background: #c41d38; }\n\n.support-old-closed-toggle {\n  width: 100%;\n  margin: 0 0 14px 0;\n  border: 1px solid #d8dae9;\n  background: #fff;\n  color: #232137;\n  font-size: 0.98rem;\n  font-weight: 700;\n  border-radius: 14px;\n  padding: 11px 12px 9px 12px;\n  cursor: pointer;\n  font-family: 'Cera Pro', Arial, sans-serif;\n  box-shadow: 0 2px 10px 0 rgba(36,41,57,0.06);\n}\n\n.support-old-closed-toggle:active {\n  background: #f5f6fb;\n}\n\n@media (max-width: 430px) {\n  .support-header-actions {\n    justify-content: stretch;\n  }\n\n  .support-new-ticket-btn {\n    width: 100%;\n    align-self: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
